import controller from './fast-import-modal.controller';
import template from './fast-import-modal.html';

/**
 * @param {any} resolve
 * @returns {import('angular').ui.bootstrap.IModalSettings}
 */
export default ({ resolve }) => ({
	template,
	resolve,
	backdrop:     'static',
	size:         'full',
	controller,
	controllerAs: '$ctrl',
});
